// Centralized API Configuration
export const API_URL = 'https://api.topupfamily.com';
